
import postcssStyledJsxUrlLoader_0 from './images/customer-engagement.svg';
import postcssStyledJsxUrlLoader_1 from './images/customer-support.svg';
import postcssStyledJsxUrlLoader_2 from './images/lead-generation.svg';
import postcssStyledJsxUrlLoader_3 from './images/HeartIcon.svg';
import css from 'styled-jsx/css';

export default css`.timeline-section-wrapper {
  display: grid;
  grid-template-columns: 1fr [content] 12fr 1fr;
}

.timeline-section {
  grid-area: content;
  margin: 50px auto 0;
  width: 100%;
  max-width: $container-max-width;
  background-color: $stone;
  text-align: center;
  border-radius: 5px;
  padding: 80px 0 20px 0;
  position: relative;

  @include media-query(tablet) {
    margin: 0 auto;
  }
}

.timeline__image {
  width: 160px;
  position: absolute;
  transform: translate(-50%, -50%);
  left: 50%;
  top: 0;

  @include media-query(tablet) {
    width: 220px;
  }
}

.timeline-section h1 {
  max-width: 650px;
  margin: 0 auto 20px;
  padding: 0 20px;
}

.timeline {
  margin: 40px auto 20px;
  width: 100%;

  @include media-query(tablet) {
    margin: 200px auto 50px;
  }
}

.timeline__arrow-btn {
  height: 35px;
  width: 35px;
  border-radius: 50%;
  background-color: black;
  position: absolute;
  top: 320px;
  transform: translate(-50%, -50%);
  z-index: 2;
  padding: 0;
  outline: none;
  cursor: pointer;
  opacity: 1;
  transition: opacity 0.8s;

  img {
    position: absolute;
    left: 50%;
    top: 50%;
    height: 15px;
    pointer-events: none;
  }

  &--prev {
    left: 0;

    img {
      transform: translate(-50%, -50%) rotate(180deg);
    }
  }

  &--next {
    left: 100%;

    img {
      transform: translate(-50%, -50%);
    }
  }

  @include media-query(tablet) {
    display: none;
  }
}

.timeline__list {
  position: relative;
  width: 80%;
  margin: 0 13% 0 7%;
  padding-right: 50px;
  height: 55px;

  @include media-query(tablet) {
    height: 80px;
  }
}

.timeline__list li {
  position: absolute;
  height: 0px;
  width: 10px;
  height: 60px;
  top: 0;
  transition: left 0.4s ease, top 0.4s ease;

  @include media-query(tablet) {
    cursor: pointer;
    height: 100px;
    width: 30px;
  }
}
.timeline__list li::after {
  @include media-query(tablet) {
    position: absolute;
    content: '';
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background-color: white;
    box-shadow: 0 1px 2px rgba(200, 200, 200, 0.7);
    bottom: 0;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.timeline__card-icon {
  height: 40px;
  width: 40px;
  border-radius: 50%;
  border: 3px solid white;

  position: absolute;
  transform: translateX(-50%);
  left: 50%;
  z-index: 0;

  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;

  &--support {
    background-image: url("${postcssStyledJsxUrlLoader_0}");
  }
  &--sales {
    background-image: url("${postcssStyledJsxUrlLoader_1}");
  }
  &--marketing {
    background-image: url("${postcssStyledJsxUrlLoader_2}");
  }
  &--all-in-one {
    background-image: url("${postcssStyledJsxUrlLoader_3}");
  }

  @include media-query(tablet) {
    height: 60px;
    width: 60px;
    transition: transform 0.4s ease;
  }
}

.timeline__card-icon::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  height: 0;
  width: 0;
  border-top: 13px solid white;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;

  @include media-query(tablet) {
    border-top: 16px solid white;
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
  }
}

.timeline__card {
  box-shadow: 0 4px 10px rgba(200, 200, 200, 0.8);
  background-color: white;
  height: 140px;
  margin: 20px auto 60px;
  width: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px;
  border-radius: 5px;
  cursor: default;
  position: relative;

  @include media-query(tablet) {
    position: absolute;
    margin: 0 auto;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0.25);
    opacity: 0;
    transition: transform 0.4s ease, opacity 0.4s;
    height: 220px;
    width: 285px;

    &::after {
      content: '';
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      height: 0;
      width: 0;
      border-top: 16px solid white;
      border-left: 15px solid transparent;
      border-right: 15px solid transparent;
    }
  }
}

.timeline__card-date {
  margin-bottom: 10px;
  font-size: 12px;

  @include media-query(tablet) {
    font-size: 18px;
  }
}
.timeline__card-title {
  font-size: 16px;
  font-weight: bold;

  @include media-query(tablet) {
    font-size: 24px;
  }
}
.timeline__card-link {
  margin-top: 12px;
  font-size: 12px;

  @include media-query(tablet) {
    font-size: 16px;
    margin-top: 20px;
  }
}

@media (max-width: 767px) {
  .timeline__list li.mobile-active {
    top: -95%;
  }
}

.timeline__list li:hover .timeline__card {
  position: relative;
  transform: translate(-50%, -57%) scale(1);
  opacity: 1;
  z-index: 1;
}
.timeline__list li:hover .timeline__card,
.timeline__list li.active .timeline__card {
  @include media-query(tablet) {
    position: relative;
    transform: translate(-50%, -57%) scale(1);
    opacity: 1;
    z-index: 1;
    position: absolute;
    transform: translate(-50%, -90%) scale(1);
  }
}
.timeline__list li:hover .timeline__card-icon,
.timeline__list li.active .timeline__card-icon {
  @include media-query(tablet) {
    transform: translate(-50%, -275px);
    z-index: 2;
    box-shadow: 0 2px 6px rgba(200, 200, 200, 0.7);
    transform: translate(-50%, -190px);
  }
}
.timeline__list li:hover .timeline__card-icon::after,
.timeline__list li.active .timeline__card-icon::after {
  @include media-query(tablet) {
    display: none;
  }
}

.timeline__card-link {
  color: $slate;
  background-color: $gray;
  padding: 8px 24px;
  border-radius: 4px;
}

.timeline__bar {
  width: 90%;
  height: 7px;
  border-radius: 6px;
  background-color: white;
  margin: 3px auto;
}

.timeline__labels {
  display: flex;
  justify-content: space-between;
  width: 90%;
  margin: 20px auto;
  color: $ui-gray;
}

.timeline__legend {
  margin: 30px auto 0;
  display: flex;
  flex-wrap: wrap;
  text-align: center;
  justify-content: center;
}

.timeline__legend span {
  position: relative;
  padding: 0 30px 20px 30px;
}
.timeline__legend span::before {
  content: '';
  position: absolute;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  left: 10px;
  top: 4px;
  background-color: $aqua;
}

.timeline__legend span:nth-of-type(1)::before {
  background-color: $aqua;
}
.timeline__legend span:nth-of-type(2)::before {
  background-color: $coral;
}
.timeline__legend span:nth-of-type(3)::before {
  background-color: $violet;
}
.timeline__legend span:nth-of-type(4)::before {
  background-color: $tangerine;
}
`